import rootReducer from 'store/reducers';

import { AUTH_REDUCER_KEY } from 'app-components/flux/auth';
import { coreActions } from 'app-components/flux/core-actions';
import store, { immutableSerialize } from 'app-components/utils/redux-store';

import { APP_REDUCER_KEY } from 'data/app/reducer';
import { stripCredentials } from 'utils/stripCredentials';

export const copyState = (sanitize = false): Blob => {
  if (!store) throw new Error('no store to copy');
  const state = store.getState();
  const dump = immutableSerialize.convertToJSRecursive(sanitize ? rootReducer(state, coreActions.sanitize()) : state);
  // With its tokens gone, a loaded file still has to pass the sign-in check. Its requests stay blocked.
  dump[AUTH_REDUCER_KEY].isSanitized = true;
  dump[APP_REDUCER_KEY].isSanitized = true;
  return new Blob([JSON.stringify(stripCredentials(dump))], { type: 'application/json' });
};

export const saveStore = (name = 'store.js', sanitize = false): void => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(copyState(sanitize));
  link.download = name;
  link.click();
};
